const selectUserActions = state => state.data.userActions

const UserActionDataStoreSelectors = {
  userActions: selectUserActions
}

export default UserActionDataStoreSelectors
